import { find, includes, some } from "lodash";
import PaymentDto from "../../PaymentContainerClient/dtos/PaymentDto";

export default function getFirstPaymentWithAtLeastOneSelectedInstallments(
    payments: PaymentDto[],
    installmentIds: string[]
): PaymentDto | undefined {
    return find(payments, (payment) =>
        some(payment.installmentIds, (installmentId) =>
            includes(installmentIds, installmentId)
        )
    );
}
